import { Component } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-products-header-banner',
  templateUrl: './products-header-banner.component.html',
  styleUrl: './products-header-banner.component.scss',
  standalone: false
})
export class ProductsHeaderBannerComponent {
  Images = IMAGES
}
